module.exports = {
  KANJI_GAME: '/kanjigame',
  SHIRITORI: '/shiritori',
};
